import React from "react";
import { Link } from "react-router-dom";
import {
  constants,
  DateFormat,
} from "../../../Containers/Constants/commenFeatures";

const VideoBanner = ({ video }) => {
  return (
    <div className="tradingAlgoInto">
      <div className="videoBox">
        <div>
          <iframe
            width="100%"
            height="100%"
            src={video && video.url}
            title="YouTube video player"
            frameborder="0"
            allowfullscreen
            allow="fullscreen"
          ></iframe>
        </div>
      </div>
      <div className="tradingAlgoInto-text">
        <Link to={`videos/${video.resourceId}`}>
          <h2>{video && video.name}</h2>
        </Link>
        <p className="date">
          {video ? DateFormat(video.date, constants.resourceDateFormat) : ""}
        </p>
      </div>
    </div>
  );
};

export default VideoBanner;
